// Select all FAQ question elements
document.querySelectorAll('.faq-question').forEach((question) => {
    question.addEventListener('click', () => {
        const answer = question.nextElementSibling;

        // Check if the answer is currently visible
        if (answer.style.display === 'block') {
            // Hide the answer and remove the active class
            answer.style.display = 'none';
            question.classList.remove('active');
        } else {
            // Hide all other answers
            document.querySelectorAll('.faq-answer').forEach((ans) => {
                ans.style.display = 'none';
            });

            // Remove active class from all other questions
            document.querySelectorAll('.faq-question').forEach((q) => {
                q.classList.remove('active');
            });

            // Show the clicked answer and add the active class
            answer.style.display = 'block';
            question.classList.add('active');
        }
    });
});
